import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Hook to fetch tickets of a given type ('ingreso' or 'salida') filtered by an array of ids.
 */
export function useTickets(tipo, ids) {
  const [tickets, setTickets] = useState([]);
  const idsKey = Array.isArray(ids)
    ? ids.map((item) => (typeof item === 'object' ? item?.id : item)).filter(Boolean).join(',')
    : '';

  useEffect(() => {
    if (!idsKey) {
      setTickets([]);
      return;
    }
    let cancelled = false;
    axios
      .get(`${API_URL}/tickets-${tipo}/`, { params: { ids: idsKey } })
      .then((resp) => {
        if (cancelled) return;
        const data = Array.isArray(resp.data) ? resp.data : resp.data.results || [];
        setTickets(data);
      })
      .catch((err) => {
        console.error('Error fetching tickets', err);
      });
    return () => {
      cancelled = true;
    };
  }, [idsKey, tipo]);

  return tickets;
}
